const refreshCssVars = (estilo) => {
  if (estilo == null) return

  const root = document.querySelector(':root')

  if (estilo.aplicacao) {
    root.style.setProperty('--cor-primaria-aplicacao', estilo.aplicacao.corPrimariaAplicacao)
    root.style.setProperty('--cor-primaria-aplicacao-transparent', estilo.aplicacao.corPrimariaAplicacao + '0d')
    root.style.setProperty('--cor-primaria-aplicacao-semi-transparent', estilo.aplicacao.corPrimariaAplicacao + '2d')
    root.style.setProperty('--cor-secundaria-aplicacao', estilo.aplicacao.corSecundariaAplicacao)
    root.style.setProperty('--cor-fundo-aplicacao', estilo.aplicacao.corFundoAplicacao)
  }

  if (estilo.botaoNegativo) {
    root.style.setProperty('--cor-botao-negativo', estilo.botaoNegativo.corBotaoNegativo)
    root.style.setProperty('--cor-texto-botao-negativo', estilo.botaoNegativo.corBotaoNegativo)
  }

  if (estilo.botaoPrincipal) {
    root.style.setProperty('--cor-botao-principal', estilo.botaoPrincipal.corBotaoPrincipal)
    root.style.setProperty('--cor-botao-texto-principal', estilo.botaoPrincipal.corTextoBotaoPrincipal)
    root.style.setProperty('--cor-texto-botao-principal', estilo.botaoPrincipal.corBotaoPrincipal)
  }

  if (estilo.botaoSecundario) {
    root.style.setProperty('--cor-botao-secundario', estilo.botaoSecundario.corBotaoSecundario)
    root.style.setProperty('--cor-texto-botao-secundario', estilo.botaoSecundario.corTextoBotaoSecundario)
  }

  if (estilo.dashboard) {
    root.style.setProperty('--cor-icone-dashboard', estilo.dashboard.corIconeDashboard)
    root.style.setProperty('--cor-texto-dashboard', estilo.dashboard.corTextoDashboard)
  }

  if (estilo.formBuilder) {
    root.style.setProperty('--cor-principal-form-builder', estilo.formBuilder.corPrincipalFormBuilder)
    root.style.setProperty('--cor-erro-form-builder', estilo.formBuilder.corErroFormBuilder)
    root.style.setProperty('--cor-alerta-form-builder', estilo.formBuilder.corAlertaFormBuilder)
  }

  if (estilo.navegacao) {
    root.style.setProperty('--cor-fundo-navegacao', estilo.navegacao.corFundoNavegacao)
    root.style.setProperty('--cor-titulo-navegacao', estilo.navegacao.corTituloNavegacao)
    root.style.setProperty('--cor-icone-navegacao', estilo.navegacao.corIconeNavegacao)
    root.style.setProperty('--cor-voltar-navegacao', estilo.navegacao.corVoltarNavegacao)
    root.style.setProperty('--cor-subtitulo-navegacao', estilo.navegacao.corSubtituloNavegacao)
    root.style.setProperty('--cor-aba-navegacao', estilo.navegacao.corAbaNavegacao)
  }

  if (estilo.statusBar) {
    root.style.setProperty('--cor-fundo-status-bar', estilo.statusBar.corFundoStatusBar)
    root.style.setProperty('--status-bar-style', estilo.statusBar.statusBarStyle)
  }

  if (estilo.tabbar) {
    root.style.setProperty('--cor-icone-tabbar-selecionado', estilo.tabbar.corIconeTabbarSelecionado)
    root.style.setProperty('--cor-icone-tabbar-padrao', estilo.tabbar.corIconeTabbarPadrao)
    root.style.setProperty('--cor-texto-tabbar', estilo.tabbar.corIconeTabbarPadrao)
  }
}

export default refreshCssVars
